module.exports = __webpack_public_path__ + "static/media/hashtag.b0418622.svg";